<template>
  <div>
    <div class="mask"></div>

    <div class="cookie-notice">
      <img src="@/assets/pcImg/our-cookies.png" />
      <div class="title">Our use of cookies</div>
      <p>
        We use cookies to improve the functionality and performance of our
        website,to analyse web traffic and for advertising purposes.
      </p>

      <div class="three-boxs">
        <div class="cookies-settings" @click="mask2Show = true">
          Cookies Settings
        </div>
        <div class="not-accept" @click="notAccept">Don’t Accept</div>
        <div class="accept" @click="accept">Accept</div>
      </div>
    </div>

    <div class="mask2" v-if="mask2Show"></div>
    <div class="privacy" v-if="mask2Show">
      <div class="privacy-logo">
        <img src="@/assets/pcImg/logo.png" />
      </div>
      <div class="privacy-main">
        <div class="privacy-title">Privacy Preference Center</div>
        <p>
          When you visit a website, this information may Retrieve or save
          browser. This usually takes the form of: Cookies. This may include
          information about you, your Settings or your device act. In most
          cases, the information is used to perform the expected function of the
          website ensure. Through this information you will normally not
          directly identified. However, this will allow you to more personalized
          web experience. Since we have your right to Respect privacy, you can
          choose to select certain types do not allow cookies. Click on the
          different Category headings to learn more and our Change default
          settings. The blocking of certain types of However, cookies can lead
          to an impaired experience with the website and services provided to
          us.
        </p>
        <div class="information">More information</div>
        <div class="allow-all" @click="changeChecked">Allow All</div>
        <div class="privacy-title">Manage Consent Preferences</div>
        <div class="privacy-box">
          <div class="privacy-line">
            <div class="show">
              <div class="left">
                <img @click="changeiocn('strictly')" :src="strictly" />
                <div>Strictly Necessary Cookies</div>
              </div>
              <div class="right">Always Active</div>
            </div>
            <div class="none">
              <p>
                These cookies are necessary for the functioning of the website
                and cannot be disabled in your systems. Usually these cookies
                are only used in response to Actions set that correspond to a
                service request, such as for example setting your privacy
                settings, logging in or filling out forms. You can configure
                your browser as follows: set that these cookies block or you can
                use them Cookies are notified. Some areas of the website But
                they don't work. These cookies do not store personal data.
              </p>
            </div>
          </div>
          <div class="privacy-line">
            <div class="show">
              <div class="left">
                <img @click="changeiocn('performance')" :src="performance" />
                <div>Performance Cookies</div>
              </div>
              <div class="right">
                <van-switch size="25" v-model="checked1" />
              </div>
            </div>
            <div class="none">
              <p>
                These cookies allow us to track visits and traffic sources to
                measure the performance of our website, and can improve. They
                support us in answering the Questions about which pages are the
                most popular, which are the least and how visitors move around
                the website. All information collected by these cookies is
                aggregated and are therefore anonymous. If you do not accept
                these cookies allow, we cannot know when you visit our website
                have visited.
              </p>
            </div>
          </div>
          <div class="privacy-line">
            <div class="show">
              <div class="left">
                <img @click="changeiocn('functional')" :src="functional" />
                <div>Functional Cookies</div>
              </div>
              <div class="right">
                <van-switch size="25" v-model="checked2" />
              </div>
            </div>
            <div class="none">
              <p>
                With these cookies, the website is able to Provide functionality
                and personalization. You can are set by us or by third parties
                whose services we use on our pages. If you do not accept these
                cookies allow some or all of these services to work maybe not
                perfect.
              </p>
            </div>
          </div>
        </div>
        <div class="choices" @click="confirmChoices">Confirm My choices</div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      mask2Show: false,
      strictly: require("@/assets/pcImg/plus.png"),
      strictlyShow: false,
      performance: require("@/assets/pcImg/plus.png"),
      performanceShow: false,
      functional: require("@/assets/pcImg/plus.png"),
      functionalShow: false,
      checked1: false,
      checked2: false,
    };
  },
  methods: {
    notAccept() {
      this.$store.commit("setCookieNoticeShow", false);
      Cookies.set("notaccept", true);
      Cookies.set("performance", false, { expires: 3650000 });
      Cookies.set("functional", false, { expires: 3650000 });
      Cookies.set("login", false, { expires: 3650000 });
    },
    changeiocn(type) {
      switch (type) {
        case "strictly":
          if (!this.strictlyShow) {
            this.strictly = require("@/assets/pcImg/minus.png");
            document.getElementsByClassName("none")[0].className =
              "none not-none";
          } else {
            this.strictly = require("@/assets/pcImg/plus.png");
            document.getElementsByClassName("none")[0].className = "none";
          }
          this.strictlyShow = !this.strictlyShow;
          break;
        case "performance":
          if (!this.performanceShow) {
            this.performance = require("@/assets/pcImg/minus.png");
            document.getElementsByClassName("none")[1].className =
              "none not-none";
          } else {
            this.performance = require("@/assets/pcImg/plus.png");
            document.getElementsByClassName("none")[1].className = "none";
          }
          this.performanceShow = !this.performanceShow;
          break;
        case "functional":
          if (!this.functionalShow) {
            this.functional = require("@/assets/pcImg/minus.png");
            document.getElementsByClassName("none")[2].className =
              "none not-none";
          } else {
            this.functional = require("@/assets/pcImg/plus.png");
            document.getElementsByClassName("none")[2].className = "none";
          }
          this.functionalShow = !this.functionalShow;
          break;
        default:
          break;
      }
    },
    changeChecked() {
      this.checked1 = true;
      this.checked2 = true;
    },
    confirmChoices() {
      Cookies.set("performance", this.checked1, { expires: 3650000 });
      Cookies.set("functional", this.checked2, { expires: 3650000 });
      Cookies.set("login", true, { expires: 3650000 });
      this.$store.commit("setCookieNoticeShow", false);
    },
    accept() {
      Cookies.set("performance", true, { expires: 3650000 });
      Cookies.set("functional", true, { expires: 3650000 });
      Cookies.set("login", true, { expires: 3650000 });
      this.$store.commit("setCookieNoticeShow", false);
    },
  },
  created() {
    // 为checked1，checked2赋值
    if (Cookies.get("performance") == "true") this.checked1 = true;
    if (Cookies.get("performance") == "false") this.checked1 = false;
    if (Cookies.get("functional") == "true") this.checked2 = true;
    if (Cookies.get("functional") == "false") this.checked3 = false;
  },
};
</script>
<style scoped>
/* 遮罩 */
.mask {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  z-index: 9999;
}
.mask2 {
  background-color: rgba(133, 133, 133, 0.9);
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  z-index: 999999;
}

.cookie-notice {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 520px;
  height: 336.875px;
  background-color: #fff;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #232323;
  font-weight: bold;
  overflow: auto;
}
.cookie-notice > img {
  width: 36.25px;
  height: 47.5px;
  margin-top: 51.25px;
}
.cookie-notice > .title {
  font-size: 25.625px;
  margin-top: 13.75px;
}
.cookie-notice > p {
  width: calc(100% - 60px);
  font-size: 10px;
  margin-top: 31.2px;
  line-height: 15px;
}
.cookie-notice > .three-boxs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;
  width: calc(100% - 60px);
  font-size: 12.5px;
}
.three-boxs > div {
  cursor: pointer;
  color: #2e67ea;
  width: 122.5px;
  text-align: center;
}
.not-accept {
  border: 0.625px solid #2e67ea;
  height: 31.25px;
  line-height: 31.25px;
  border-radius: 31.25px;
}
.three-boxs > .accept {
  border: 0.625px solid #2e67ea;
  background-color: #2e67ea;
  color: #fff;
  height: 31.25px;
  line-height: 31.25px;

  border-radius: 31.25px;
}

/* 第二页 */
.privacy {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 438.75px;
  height: calc(90vh - 40px);
  padding-bottom: 40px;
  background-color: #fff;
  z-index: 9999999;
  border: 0.625px solid #707070;
  overflow: auto;
}
.privacy-logo {
  height: 47.5px;
  border-bottom: 0.625px solid #e4e5e9;
}
.privacy-logo > img {
  width: 111.875px;
  height: 22.5px;
  margin-top: 15px;
  margin-left: 31.25px;
}
.privacy-main {
  width: calc(100% - 62.5px);
  padding-left: 31.25px;
  padding-right: 31.25px;
  font-size: 10px;
  padding-top: 12.5px;
}
.privacy-title {
  font-weight: bold;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
}
.privacy-main > p {
  line-height: 14px;
  margin-bottom: 12.5px;
}
.information {
  color: #2e67ea;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
}
.allow-all {
  width: 79.375px;
  height: 22.5px;
  background: #2e67ea;
  color: #fff;
  text-align: center;
  line-height: 22.5px;
  border-radius: 1.25px;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
  cursor: pointer;
}
.privacy-box {
  widows: 100%;
  border: 0.625px solid #cccccc;
}
.privacy-line {
  widows: 100%;
}
.privacy-line > .show {
  display: flex;
  justify-content: space-between;
  height: 31.25px;
  align-items: center;
  border-bottom: 0.625px solid #cccccc;
  font-weight: bold;
}
.privacy-line > .show > .left {
  display: flex;
}
.privacy-line > .show > .right {
  color: #2e67ea;
  margin-right: 10px;
  cursor: pointer;
}
.privacy-line > .show > .left > img {
  width: 10px;
  height: 10px;
  margin-left: 6px;
  margin-right: 8px;
  cursor: pointer;
}
.none {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s;
  background-color: #f2f2f2;
  line-height: 15px;
  padding: 0;
}
.none > p {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.not-none {
  max-height: 100000px;
}

.choices {
  width: 103.75px;
  height: 22.5px;
  font-size: 8.75px;
  font-weight: bold;
  color: #ffffff;
  background-color: #2e67ea;
  float: right;
  margin-top: 25px;
  text-align: center;
  line-height: 22.5px;
  cursor: pointer;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 900px) {
  .cookie-notice {
    width: 88vw;
    height: 90vh;
  }
  .cookie-notice > .three-boxs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .three-boxs > div {
    cursor: pointer;
    color: #2e67ea;
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .three-boxs > div:first-child {
    text-align: left;
  }
}
@media only screen and (max-width: 800px) {
  .cookie-notice > .title {
    font-size: 20px;
  }
  .cookie-notice > p {
    font-size: 10px;
    font-weight: normal;
  }
  .three-boxs > div {
    font-size: 10px;
  }
  .three-boxs > div:first-child {
    font-weight: normal;
  }
}
@media only screen and (max-width: 750px) {
  .privacy {
    width: 90vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/cookieNotice.vue